import type {ServerError} from '@logistics-frontend/core/utils/network'
import {useTransition} from '@yandex-delivery/blocks'
import {useCallback} from 'react'

import {useUserSettingsContext} from 'src/shared/contexts'
import type {OrderAvailabilityError} from 'src/shared/types'

import {fetchOrderAvailability} from '../utils/fetch-order-availability'

export function useFetchOrderAvailability() {
  const {clientId = '', country, makeApiUrl} = useUserSettingsContext()
  const [{isPending, payload, error}, startTransition] = useTransition<{}, ServerError<OrderAvailabilityError>>(
    undefined,
    {
      key: 'order-availability',
    },
  )

  const fetchOrderAvailabilityHandler = useCallback(() => {
    startTransition(() => {
      return fetchOrderAvailability(clientId, country, makeApiUrl)
    })
  }, [clientId, country, makeApiUrl])

  return {
    error,
    fetchOrderAvailabilityHandler,
    isOrderAvailabilityPending: isPending,
    orderAvailability: payload,
  }
}
